import Vue from "vue";
import Router from "vue-router";
import loadAsync from "./util";

Vue.use(Router);
const routes = [
    {
        path: "/login",
        name: "Auth0Login",
        component: loadAsync("auth0/Login")
    },
    {
        path: "/login/unauthorized",
        name: "Unauthorized",
        component: loadAsync("auth0/Unauthorized")
    },
    {
        path: "/login/paymenterror",
        name: "PaymentError",
        component: loadAsync("auth0/PaymentError")
    },
    {
        path: "/login/error",
        name: "Error",
        component: loadAsync("auth0/Error")
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/login"
    }
];

const router = new Router({
    mode: "history",
    routes
});

export default router;
